import { SdkState } from "@idw-types/state";
import { SdkActions, SdkActionTypes } from "../actions/sdk-actions";

export const initialSDKState: SdkState = {
    isDownloadingAcuantSDK: false,
    hasDownloadedAcuantSDK: false,
    hasAcuantSDKError: false
};

export const sdkReducer = (state: SdkState = initialSDKState, action: SdkActions) => {
    switch (action.type) {
        case SdkActionTypes.SET_IS_DOWNLOADING_ACUANT_SDK:
            return {
                ...state,
                isDownloadingAcuantSDK: true,
                hasDownloadedAcuantSDK: false,
                hasAcuantSDKError: false
            };
        case SdkActionTypes.SET_DOWNLOADING_ACUANT_SDK_SUCCESS:
            return {
                ...state,
                isDownloadingAcuantSDK: false,
                hasDownloadedAcuantSDK: true,
                hasAcuantSDKError: false
            };
        case SdkActionTypes.SET_DOWNLOADING_ACUANT_SDK_FAILED:
            return {
                ...state,
                isDownloadingAcuantSDK: false,
                hasDownloadedAcuantSDK: true,
                hasAcuantSDKError: true
            };
        default:
            return state;
    }
};